import { ChildrenProps, toasterOptions } from '@dfl/mui-react-common';
import { AuthControl, SecurityProvider } from '@dfl/react-security';
import { CssBaseline, ThemeProvider } from '@mui/material';
import QueryProvider from 'contexts/QueryContext';
import { useSettings } from 'contexts/SettingsProvider';
import { SidebarProvider } from 'layouts/contexts/SidebarContext';
import { Toaster } from 'react-hot-toast';

type AppContentProps = {
  children: any;
};

const AppContent = ({ children }: AppContentProps) => {
  return (
    <>
      <AuthControl />
      {children}

      <CssBaseline />
      <Toaster toastOptions={toasterOptions} />
    </>
  );
};

export const AppProvider = ({ children }: ChildrenProps) => {
  const { theme } = useSettings(); // App theme

  return (
    <QueryProvider>
      <ThemeProvider theme={theme}>
        <SecurityProvider>
          <SidebarProvider>
            <AppContent>{children}</AppContent>
          </SidebarProvider>
        </SecurityProvider>
      </ThemeProvider>
    </QueryProvider>
  );
};
